import Matter, { World } from "matter-js";
import { Constants } from "../common/Constants";
import { randomBetween } from "../common/Utilities";
import Barrier from "../entities/Barrier";
import Flyer from "../entities/Flyer";
import Pipe from "../entities/Pipe";

let pipes = 0;
let barriers = 0;

export const generatePipeHeights = () => {
  let gapReducer = Math.floor(pipes / 10) * Constants.DIFFICULTY_MULTIPLIER;
  let gapSize = Math.max(Constants.GAP_SIZE - gapReducer, 200);
  let topPipeHeight = randomBetween(100, Constants.MAX_HEIGHT / 2 - 100);
  let bottomPipeHeight = Constants.MAX_HEIGHT - topPipeHeight - gapSize;

  let sizes = [topPipeHeight, bottomPipeHeight];

  if (Math.random() < 0.5) {
    sizes = sizes.reverse();
  }

  return sizes;
};

export const resetWorld = () => {
  pipes = 0;
  barriers = 0;
};

export const addPipes = (x: number, world: World, entities: Entities) => {
  let [pipe1Height, pipe2Height] = generatePipeHeights();

  let pipe1 = Matter.Bodies.rectangle(
    x,
    pipe1Height / 2,
    Constants.PIPE_WIDTH,
    pipe1Height,
    { isStatic: true }
  );

  let pipe2 = Matter.Bodies.rectangle(
    x,
    Constants.MAX_HEIGHT - Constants.BARRIER_HEIGHT - pipe2Height / 2,
    Constants.PIPE_WIDTH,
    pipe2Height,
    { isStatic: true }
  );

  Matter.World.add(world, [pipe1, pipe2]);

  entities["pipe" + (pipes + 1)] = {
    body: pipe1,
    renderer: Pipe,
    scored: false,
    style: { zIndex: 0 },
    class: "top",
  };

  entities["pipe" + (pipes + 2)] = {
    body: pipe2,
    renderer: Pipe,
    scored: false,
    style: { zIndex: 0 },
    class: "bottom",
  };

  pipes += 2;
};

export const addBarriers = (x: number, world: World, entities: Entities) => {
  let floor = Matter.Bodies.rectangle(
    x,
    Constants.MAX_HEIGHT - Constants.BARRIER_HEIGHT / 2,
    Constants.BARRIER_WIDTH,
    Constants.BARRIER_HEIGHT,
    { isStatic: true }
  );

  let ceiling = Matter.Bodies.rectangle(x, -1, Constants.BARRIER_WIDTH, 1, {
    isStatic: true,
  });

  Matter.World.add(world, [floor, ceiling]);

  entities["barrier" + (barriers + 1)] = {
    body: ceiling,
    backgroundColor: "#647499",
    renderer: Barrier,
    class: "ceiling",
  };

  entities["barrier" + (barriers + 2)] = {
    body: floor,
    backgroundColor: "#647499",
    renderer: Barrier,
    class: "floor",
  };

  barriers += 2;
};

export const generateWorld = (world: World, entities: Entities) => {
  let firstBarrier = Constants.BARRIER_WIDTH / 2;
  addBarriers(firstBarrier, world, entities);
  addBarriers(firstBarrier + Constants.BARRIER_WIDTH, world, entities);

  return entities;
};

export const generatePipes = (world: World, entities: Entities) => {
  let firstPipe = Constants.MAX_WIDTH / 2 + Constants.PIPE_WIDTH * 8;
  addPipes(firstPipe, world, entities);
  addPipes(firstPipe + Constants.PIPE_GAP, world, entities);

  return entities;
};

export const generatePlayer = (world: World) => {
  let flyer = Matter.Bodies.rectangle(
    Constants.MAX_WIDTH / 2,
    Constants.MAX_HEIGHT / 2 - Constants.FLYER_HEIGHT / 2,
    Constants.FLYER_WIDTH,
    Constants.FLYER_HEIGHT,
    { isStatic: true }
  );

  Matter.World.add(world, [flyer]);

  return {
    body: flyer,
    backgroundColor: "#0000ff",
    renderer: Flyer,
  };
};
